const checkInStoreSelectors = {
  drawerContent: '[data-check-in-store-content]',
  availability: '[data-store-availability]',
  drawerAccordion: '.custom-accordion',
  drawerAccordionTrigger: '.custom-accordion__trigger',
  drawerAccordionPanel: '.custom-accordion__panel'
}

class CheckInStoreDrawer extends BaseDrawer {
  constructor() {
    const globalSelectors = {
      triggerButton: '[data-check-in-store-button]',
      drawer: '[data-check-in-store-drawer]',
      overlay: '[data-check-in-store-drawer-overlay]'
    };
    super(globalSelectors);

    this.init();
  }

  init() {
    this.productData = [];
    this.rootUrl = this.dataset.rootUrl.endsWith('/') ? this.dataset.rootUrl : `${this.dataset.rootUrl}/`;
    this.fetchAvailability(this.dataset.variantId);

    // Refetch availability based on selected variant
    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleOptionValueChange.bind(this)
    );
  }

  async fetchAvailability(variantId) {
    if (!variantId) return;

    try {
      const rootUrl = this.rootUrl;

      const inventoryData = await this.fetchInventoryData(rootUrl, variantId);

      this.renderPreview(inventoryData);
    } catch (error) {
      console.error('Error fetching availability:', error);
    }
  }

  async fetchInventoryData(rootUrl, variantId) {
    const response = await fetch(`${rootUrl}variants/${variantId}/?section_id=check-in-store`);
    if (!response.ok) throw new Error('Variant section fetch failed');

    const text = await response.text();
    const sectionInnerHTML = new DOMParser()
      .parseFromString(text, 'text/html')
      .querySelector('.shopify-section');

    if (!sectionInnerHTML) throw new Error('Section HTML not found');
    return sectionInnerHTML;
  }

  renderPreview(sectionInnerHTML) {
    const content = document.querySelector(checkInStoreSelectors.drawerContent);
    content.innerHTML = sectionInnerHTML.outerHTML;

    this.initAccordions();
  }

  handleOptionValueChange(event) {
    const variantId = event.data.variant.id;
    this.fetchAvailability(variantId);
  }
}

customElements.define('check-in-store-drawer', CheckInStoreDrawer);
